import { useAuth } from '../context/AppContext';

/**
 * Adaptive UI hook — reads user's onboarding profile to determine UI mode.
 *
 * Returns:
 *  - isEpure: true for Seniors OR Débutants (simplified UI, large text)
 *  - isJunior: HARD-CODED to false. YUMIX is reserved to 18+, so the "Junior"
 *    UI mode is permanently disabled. The flag is kept only for backward-compat
 *    with components that still reference it; it never evaluates true.
 *  - isSenior: true for Senior 65+
 *  - profileGroup: raw value (femme, homme, senior)
 *  - mission: raw value (perte_poids, performance, mobilite)
 *  - techLevel: raw value (debutant, expert)
 *  - adaptLabel: function to adapt labels per mode (no-op since junior is gone)
 */
export function useAdaptiveUI() {
  const { user } = useAuth();

  const profileGroup = user?.profile_group || '';
  const mission = user?.mission || '';
  const techLevel = user?.tech_level || '';

  const isSenior = profileGroup === 'senior';
  // 18+ ONLY — junior path permanently disabled (kept as `false` for compat)
  const isJunior = false;
  const isDebutant = techLevel === 'debutant';
  const isEpure = isSenior || isDebutant;

  // No-op: the junior re-labelling layer is retired (18+ only app)
  const adaptLabel = (frLabel, enLabel, lang = 'fr') => (lang === 'fr' ? frLabel : enLabel);

  return {
    isEpure,
    isJunior,
    isSenior,
    isDebutant,
    profileGroup,
    mission,
    techLevel,
    adaptLabel,
  };
}
